import React from 'react'
import { THEME_DARK } from 'constants.js'
import clsx from 'clsx'
import { useStyles } from './styles'

const SimpleRadioButtonFieldSet = ({ fieldSetId, fieldSetLabel, buttons, className, themeColor, ...props }) => {
    const classes = useStyles()
    const themeClass = themeColor === THEME_DARK ? classes.dark : classes.light
    const themeContainerClass = themeColor === THEME_DARK ? classes.darkContainer : classes.lightContainer

    return (
        <div className={clsx(classes.fieldSetContainer, themeContainerClass, className)}>
            <p className={classes.fieldSetLabel}>{fieldSetLabel}</p>
            <fieldset id={fieldSetId} className={'simple-radio-button-field-set'}>
                {Array.isArray(buttons) &&
                    buttons.map((button, i) => (
                        <div key={i}>
                            <input
                                type="radio"
                                id={`${fieldSetId}-radio${i}`}
                                value={button.btnText}
                                name={fieldSetId}
                                {...props}
                            />
                            <label htmlFor={`${fieldSetId}-radio${i}`} className={clsx(classes.label, themeClass)}>
                                {button.btnText}
                            </label>
                        </div>
                    ))}
            </fieldset>
        </div>
    )
}

export default React.memo(SimpleRadioButtonFieldSet)
